export function getDummyUserId() {
  let userId = localStorage.getItem('dummyUserId');
  if (!userId) {
    userId = 'user-' + Math.random().toString(36).slice(2, 12);
    localStorage.setItem('dummyUserId', userId);
  }
  return userId;
}
